import axios from 'axios';
import router from '../../router/routes';
import notify from './notify';

export default function getEditorData(axiosRoute) {
    return new Promise((resolve, reject) => {
        // CSRF
        axios.get(axiosRoute)

            // Success
            .then((response) => {
                resolve(response);
            })

            // If there's an error here, the item doesn't exist.
            .catch((error) => {
                // Show an error message.
                notify(error.response.data.message, 'error');
                const base = router.currentRoute.path.split('/')[1];
                router.push('/' + base + '/index');
                reject(false);
            });
    });
}
